import {useAuthStore} from "../store/auth.store";
import {useEffect, useState} from "react";
import { useTranslation } from "../hooks/useTranslation";
import {useVendorsStore} from "../store/vendors.store";
import {useVendors} from "../hook/partner/vendors.partner.hook";
import {PartnerApi} from "../api/partner.api";
import {NavLink} from "react-router";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import {useCompanyStore} from "../store/company.store";
import SettingsUsers from "./Settings/SettingsUsers";
import SettingsUsersDeliveryAddress from "./Settings/SettingsDeliveryAddress";
import SettingsCompanyBranches from "./Settings/SettingsCompanyBranches";

function Settings() {
    const { t } = useTranslation();
    const [page, setPage] = useState("users");

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(()=>{
        setPagename(t("settings.title"));
        setBreadcrumbs([]);
    },[]);

    return (
        <>
            <ul className="mb-10 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                <li className="nav-item">
                    <span onClick={() => setPage("users")}
                          className={"cursor-pointer nav-link" + (page == "users" ? " active" : "")}
                          aria-current="page"
                    >
                        {t("settings.persons")}
                    </span>
                </li>
                <li className="nav-item">
                    <span onClick={() => setPage("deliveryAddress")}
                          className={"cursor-pointer nav-link" + (page == "deliveryAddress" ? " active" : "")}
                          aria-current="page"
                    >
                        {t("settings.deliveryAddresses")}
                    </span>
                </li>
                <li className="nav-item">
                    <span onClick={() => setPage("branches")}
                          className={"cursor-pointer nav-link" + (page == "branches" ? " active" : "")}
                          aria-current="page"
                    >
                        {t("settings.branches")}
                    </span>
                </li>
            </ul>


            {page == "users" && (
                <SettingsUsers/>
            )}

            {page == "deliveryAddress" && (
                <SettingsUsersDeliveryAddress/>
            )}
            {page == "branches" && (
                <SettingsCompanyBranches/>
            )}
        </>
    );
}

export default Settings;
